import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HTTP_INTERCEPTORS,
	HttpResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { ConstantsService } from '../services/constant/constants.service';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LogService } from '../services/log/log.service';
import { FacadeService } from '../services/facade.service';
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
	private TOKEN_HEADER_KEY = 'Authorization';

	constant: ConstantsService = new ConstantsService();

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService
	) {}

	intercept(
		req: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			tap((response: HttpResponse<any>) => {
				if (response.headers && response.headers.get('Refresh')) {
					const newJwtToken = response.headers.get('Refresh');
					this.facade.dataStorageService.setJwtToken(newJwtToken);
				}
				// Return le body sinon les services vont tous plantés (ils ne s'attendent pas à une HttpResponse, juste au body,
				// comme avec le fonctionnent classique d'Angular)
				return of(response.body);
			}),
			catchError((error) => {
				if (error.status === 401) {
					this.logger.log('Unauthorized access.');
					this.clearStorage();
					this.router.navigateByUrl('/login');
				}

				return throwError(() => error);
			})
		);
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.clearSession();
		//this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
	}
}

export const httpErrorInterceptor = [
	{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }
];
